import {
  useFormContext,
  type FieldPath,
  type FieldValues,
} from "react-hook-form"
import { withMask } from "use-mask-input"

import {
  FormField,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"

export type FormInputMaskProps<T extends FieldValues = FieldValues> = {
  name: FieldPath<T>
  label?: string
  placeholder: string
  mask: string
  className?: string
  disabled?: boolean
}

export function FormInputMask<T extends FieldValues = FieldValues>({
  name,
  label,
  placeholder,
  mask,
  className,
  disabled = false,
}: FormInputMaskProps<T>) {
  const form = useFormContext<T>()

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="w-full">
          {label && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <Input
              placeholder={placeholder}
              className={className}
              disabled={disabled}
              {...field}
              ref={withMask(mask)}
              onChange={(e) => {
                field.onChange(e)
              }}
            />
          </FormControl>
          <FormMessage className="form-error" />
        </FormItem>
      )}
    />
  )
}
